import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
  display: block;
  margin-bottom: 33px;
  position: relative;
  width: 100%;
`;

export const ColRight = styled.div`
  max-width: 1147px;
  width: auto;
  display:inline-block;
  border-radius: 5px;
  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(130, 130, 130, 0.5);
  background-color: #ffffff;
  position:relative;
  margin-right:16px;
`;

export const ChipsCol = styled.div`
  width:max-content;
  display:inline-block;
`;